import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./App.css";
import { routes } from "./routes";
import userContext from "src/context/userContext";
import { useEffect, useState } from "react";
import { get } from "./services/HttpClient";
import 'react-loading-skeleton/dist/skeleton.css'


const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL,
});

function App() {
  const [user, setUser] = useState({});

  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch("/version.json", {
          cache: "no-store",
        });
        const data = await res.json();

        const currentVersion = data.version;
        const savedVersion = localStorage.getItem("app_version");

        if (!savedVersion) {
          // اولین بار
          localStorage.setItem("app_version", currentVersion);
        } else if (savedVersion !== currentVersion) {
          const confirmed = window.confirm("نسخه جدیدی از برنامه در دسترس است. آیا مایلید بروزرسانی انجام شود؟");
          if (confirmed) {
            localStorage.setItem("app_version", currentVersion);
            window.location.reload(true); // reload از سرور، نه کش
          }
        }
      } catch (err) {
        console.error("خطا در بررسی نسخه جدید:", err);
      }
    };
    checkVersion();
  }, []);


  // GET user FROM BACKEND
  const getUser = async () => {
    const result = await get("/accounts/me");
    if (result) {
      setUser(result.body);
    }
  };

  useEffect(() => {
    getUser();
  }, []);

  return (
    <userContext.Provider value={{ user, setUser }}>
      <RouterProvider router={router} />
    </userContext.Provider>
  );
}

export default App;
